import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "project-theme-budget" }
const _hoisted_2 = { class: "project-theme-budget__header" }
const _hoisted_3 = {
  key: 0,
  class: "kpi-boxes"
}
const _hoisted_4 = { class: "kpi white-box" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = {
  key: 1,
  class: "budget-approval"
}
const _hoisted_7 = { class: "horizontal-container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "themes-empty"
}
const _hoisted_11 = { class: "table-wrapper" }
const _hoisted_12 = { class: "table theme-table" }
const _hoisted_13 = { class: "row header header--sticky" }
const _hoisted_14 = { class: "cell header-cell cell--theme-amount" }
const _hoisted_15 = { class: "cell header-cell cell--theme-name" }
const _hoisted_16 = {
  key: 0,
  class: "cell header-cell cell--actions"
}
const _hoisted_17 = { class: "cell cell--theme-color" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "cell cell--theme-name" }
const _hoisted_20 = {
  key: 0,
  class: "cell cell--actions"
}
const _hoisted_21 = {
  key: 0,
  class: "table-footer"
}
const _hoisted_22 = { class: "kpi-boxes kpi-boxes--grey" }
const _hoisted_23 = { class: "kpi" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "kpi" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "chart-wrapper" }
const _hoisted_30 = { class: "chart-legend" }
const _hoisted_31 = {
  key: 2,
  class: "bottom-buttons"
}
const _hoisted_32 = {
  key: 3,
  class: "bottom-buttons"
}
const _hoisted_33 = { key: 0 }

import { useI18n } from "vue-i18n";
import enUK from "@/locales/theme/en-UK.json";
import { useMutation, useQuery } from "@vue/apollo-composable";
import { GET_PROJECT_WITH_BUDGET_AND_THEMES } from "@/graphql/project/queries";
import useMutationHandlers from "@/composables/useMutationHandlers";
import { computed, onMounted, ref, watch } from "vue";
import BasicButton from "@/components/BasicButton.vue";
import AddTheme from "@/components/CRUXEntity/AddTheme.vue";
import MergeTheme from "@/components/CRUXEntity/MergeTheme.vue";
import EditTheme from "@/components/CRUXEntity/EditTheme.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import { Theme } from "@/helpers/project/typesDefinition";
import { useToast } from "vue-toastification";
import {
  formatFullDate,
  formatPrice,
  formatPercentage,
} from "../../helpers/utils";
import BasicInput from "@/components/form/BasicInput.vue";
import {
  APPROVE_BUDGET,
  DELETE_THEME,
  NEW_BUDGET,
  SUBMIT_BUDGET,
  UPDATE_BUDGET,
} from "@/graphql/project/mutations";
import { logErrorMessages } from "@vue/apollo-util";
import { useRoute } from "vue-router";
import IconButton from "@/components/IconButton.vue";
import ButtonIcon from "@/components/ButtonIcon.vue";
import GraphLegendItem from "@/components/GraphLegendItem.vue";
import Badge from "@/components/Badge.vue";
import useProjectBudget from "@/composables/UseProjectBudget";
import ButtonContactAdmin from "@/components/ButtonContactAdmin.vue";
import useHasAccess from "@/composables/useHasAccess";
import GraphDonutWithLabel from "@/components/GraphDonutWithLabel.vue";
import { DonutDefinition, DonutSegment } from "@/helpers/typesDefinition";

type MessageSchema = typeof enUK;

interface Props {
  id: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectThemesAndBudget',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n<[MessageSchema], "en-UK">({
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const toast = useToast();
const route = useRoute();
const { createErrorHandler } = useMutationHandlers();

const { result: projectResult, onError: onGetProjectError } = useQuery(
  GET_PROJECT_WITH_BUDGET_AND_THEMES,
  () => ({ id: props.id }),
);
onGetProjectError(createErrorHandler("getProjectWithBudgetAndThemes"));

const project = computed(() => projectResult.value?.project);

// TODO: should be stored in the thematic object
const ThemeColors = [
  "#5363F5",
  "#DADFF7",
  "#FEAC20",
  "#3A3042",
  "#00C614",
  "#2603FF",
];

const themes = ref<Theme[]>();
watch(project, () => {
  const budget = project.value?.budget;
  const projectThemes = project.value?.themes.map((theme, i) => ({
    ...theme,
    color: ThemeColors[i % ThemeColors.length],
  }));

  if (!budget) {
    themes.value = projectThemes;
  } else {
    globalBudget.value = project.value.budget.amount;
    themes.value = projectThemes.map((theme) => ({
      ...theme,
      budget: budget.themes.find((t) => t.theme.id === theme.id)?.amount,
    }));
  }
});

const {
  budget,
  totalAmount,
  allocatedAmount,
  remainingToAllocateAmount,
  approvedAt,
} = useProjectBudget(project, themes);

const isAddThemeModalVisible = ref(false);
const showAddThemeModal = () => {
  isAddThemeModalVisible.value = true;
};
const closeAddThemeModal = () => {
  isAddThemeModalVisible.value = false;
};

const isMergeThemeModalVisible = ref(false);
const showMergeThemeModal = () => {
  isMergeThemeModalVisible.value = true;
};
const closeMergeThemeModal = () => {
  isMergeThemeModalVisible.value = false;
};

const themeToEditId = ref("");
const themeToEdit = computed(() => {
  return themes.value?.find((t) => t.id === themeToEditId.value);
});
const showEditThemeModal = (themeId: string) => {
  themeToEditId.value = themeId;
};
const closeEditThemeModal = () => {
  themeToEditId.value = "";
};

const isConfirmDeleteModalVisible = ref(false);
const themeToDelete = ref();
const showConfirmDelete = (theme: Theme) => {
  themeToDelete.value = theme;
  isConfirmDeleteModalVisible.value = true;
};
const closeConfirmDelete = () => {
  isConfirmDeleteModalVisible.value = false;
};

const projectId = ref("");

onMounted(() => {
  projectId.value = props.id;
});

const { hasAdminAccess, hasClientAccess } = useHasAccess(projectId);

const setThemeBudget = (themeId, value) => {
  themes.value = themes.value?.map((t) => {
    if (t.id === themeId) {
      return {
        ...t,
        budget: value * 100,
      };
    }
    return t;
  });
};

const editBudgetThemeId = ref();
const editBudgetOfTheme = (themeId) => (editBudgetThemeId.value = themeId);
const stopEditionBudgetTheme = () => (editBudgetThemeId.value = undefined);

const globalBudget = ref();
const setGlobalBudget = (value) => {
  globalBudget.value = value;
};

const isEditingGlobalBudget = ref(false);
const editGlobalBudget = () => (isEditingGlobalBudget.value = true);
const stopEditionGlobalBudget = () => (isEditingGlobalBudget.value = false);

const refetchQueries = [
  {
    query: GET_PROJECT_WITH_BUDGET_AND_THEMES,
    variables: { id: props.id },
  },
];

const {
  mutate: approveBudget,
  onDone: onDoneApprove,
  onError: onErrorApprove,
  loading: loadingApprove,
} = useMutation(APPROVE_BUDGET, () => ({
  variables: {
    id: project.value?.budget?.id,
  },
  refetchQueries,
}));

onDoneApprove(async (result) => {
  if (result.data?.approveBudget?.status === "ok") {
    isConfirmBudgetApproveModalVisible.value = false;
    toast.success(t("success.budgetapproval"));
  } else {
    const errorResponse = result.data?.approveBudget?.error;
    console.log(errorResponse);
    toast.error(t("errors.budgetapproval", { message: errorResponse }));
  }
});

onErrorApprove((error) => {
  logErrorMessages(error);
  toast.error(t("errors.budgetapproval", { message: t("errors.internal") }));
});

const isConfirmBudgetApproveModalVisible = ref(
  route.name === "ProjectBudgetDetails",
);
const closeConfirmBudgetApproveModal = () => {
  isConfirmBudgetApproveModalVisible.value = false;
};
const openConfirmBudgetApproveModal = () => {
  isConfirmBudgetApproveModalVisible.value = true;
};

const {
  mutate: submitBudget,
  onDone: onDoneSubmit,
  onError: onErrorSubmit,
} = useMutation(SUBMIT_BUDGET, () => ({
  variables: {
    id: budget.value?.id,
  },
  refetchQueries,
}));

onDoneSubmit(async (result) => {
  if (result.data?.submitBudget?.status === "ok") {
    isSubmitBudgetModalVisible.value = false;
    toast.success(t("success.budgetsubmit"));
  } else {
    const errorResponse = result.data?.submitBudget?.error;
    console.log(errorResponse);
    toast.error(t("errors.budgetsubmit", { message: errorResponse }));
  }
});

onErrorSubmit((error) => {
  logErrorMessages(error);
  toast.error(t("errors.budgetsubmit", { message: t("errors.internal") }));
});

const isSubmitBudgetModalVisible = ref(route.name === "ProjectBudgetDetails");
const closeSubmitBudgetModal = () => {
  isSubmitBudgetModalVisible.value = false;
};
const showSubmitBudgetModal = () => {
  isSubmitBudgetModalVisible.value = true;
};

const {
  mutate: deleteTheme,
  onDone: onDoneDeleteTheme,
  onError: onErrorDeleteTheme,
} = useMutation(DELETE_THEME, () => ({
  variables: {
    id: themeToDelete.value?.id,
  },
  refetchQueries,
}));

onDoneDeleteTheme(async (result) => {
  if (result.data?.deleteTheme?.status === "ok") {
    isConfirmDeleteModalVisible.value = false;
    toast.success(t("success.themedelete"));
  } else {
    const errorResponse = result.data?.deleteTheme?.error;
    console.log(errorResponse);
    toast.error(t("errors.delete", { message: errorResponse }));
  }
});

onErrorDeleteTheme((error) => {
  logErrorMessages(error);
  toast.error(t("errors.delete", { message: t("errors.internal") }));
});

const thematicPercentages = computed(() => {
  return themes.value?.reduce(
    (acc, theme) => {
      const { offset, items } = acc;

      const percentageRaw = theme.budget ? theme.budget / totalAmount.value : 0;
      const percentage = percentageRaw * 100;
      const percentageLabel = formatPercentage(percentageRaw);
      const segment = {
        ...theme,
        percentageLabel,
        percentage,
        total: totalAmount.value,
        offset,
      };

      const currentOffset = offset + (1 - percentageRaw) * 100;

      return {
        offset: currentOffset,
        items: [...items, segment],
      };
    },
    {
      offset: 0,
      items: [],
    },
  );
});

const segments = computed(() => {
  console.log(JSON.stringify(thematicPercentages.value?.items, null, 2));
  return thematicPercentages.value?.items || [];
});

const donutDefinition = computed((): DonutDefinition => {
  return {
    layers: [
      {
        id: "layer",
        segments: segments.value as DonutSegment[],
      },
    ],
  };
});

const chartLabelValue = computed(() =>
  formatPercentage(allocatedAmount.value / totalAmount.value),
);

const {
  mutate: updateBudget,
  onDone: onDoneUpdate,
  onError: onErrorUpdate,
} = useMutation(UPDATE_BUDGET, () => ({
  variables: {
    id: budget.value?.id,
    amount: globalBudget.value,
    themes:
      themes.value
        ?.filter((t) => t.budget !== undefined)
        .map((t) => ({
          themeId: t.id,
          amount: t.budget,
        })) ?? [],
  },
  refetchQueries,
}));

onDoneUpdate(async (result) => {
  if (result.data?.updateBudget?.status === "ok") {
    isSubmitBudgetModalVisible.value = false;
    toast.success(t("success.budgetupdate"));
  } else {
    const errorResponse = result.data?.updateBudget?.error;
    console.log(errorResponse);
    toast.error(t("errors.budgetupdate", { message: errorResponse }));
  }
});

onErrorUpdate((error) => {
  logErrorMessages(error);
  toast.error(t("errors.budgetupdate", { message: t("errors.internal") }));
});

const {
  mutate: newBudget,
  onDone: onDoneNew,
  onError: onErrorNew,
} = useMutation(NEW_BUDGET, () => ({
  variables: {
    projectId: project.value?.id,
    amount: globalBudget.value,
    themes:
      themes.value
        ?.filter((t) => !!t.budget)
        .map((t) => ({
          themeId: t.id,
          amount: t.budget,
        })) ?? [],
  },
  refetchQueries,
}));

onDoneNew(async (result) => {
  if (result.data?.newBudget?.status === "ok") {
    isSubmitBudgetModalVisible.value = false;
    toast.success(t("success.budgetnew"));
  } else {
    const errorResponse = result.data?.newBudget?.error;
    console.log(errorResponse);
    toast.error(t("errors.budgetnew", { message: errorResponse }));
  }
});

onErrorNew((error) => {
  logErrorMessages(error);
  toast.error(t("errors.budgetnew", { message: t("errors.internal") }));
});

const saveDraft = () => {
  if (budget.value?.status === "draft") {
    return updateBudget();
  } else {
    return newBudget();
  }
};

const isGlobalBudgetInputDisabled = computed(() => !themes.value?.length);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (_unref(budget) !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("labels.budget.totalBudget")), 1),
              _createElementVNode("p", {
                class: _normalizeClass(["value", [{ disabled: isGlobalBudgetInputDisabled.value }]]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (
              !isGlobalBudgetInputDisabled.value &&
                _unref(hasAdminAccess) &&
                editGlobalBudget()
            ))
              }, [
                (isEditingGlobalBudget.value)
                  ? (_openBlock(), _createBlock(BasicInput, {
                      key: 0,
                      input: globalBudget.value / 100,
                      onBlur: stopEditionGlobalBudget,
                      onKeyup: _withKeys(stopEditionGlobalBudget, ["enter"]),
                      onInput: _cache[0] || (_cache[0] = 
                (event) => setGlobalBudget(Number(event.target.value) * 100)
              )
                    }, null, 8, ["input"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(formatPrice)(globalBudget.value)) + " ", 1),
                      (project.value?.active && _unref(hasAdminAccess))
                        ? (_openBlock(), _createBlock(IconButton, {
                            key: 0,
                            iconName: "jam:pen-f",
                            hasBorders: false,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (!isGlobalBudgetInputDisabled.value ? null : editGlobalBudget))
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (
          project.value?.needsBudgetApproval &&
          _unref(budget) !== null &&
          _unref(budget)?.status !== 'draft'
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_unref(approvedAt) && _unref(hasAdminAccess))
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)("labels.budgetapproval.approved", {
                approvedAt: _unref(formatFullDate)(_unref(approvedAt)),
              })), 1))
                : _createCommentVNode("", true),
              (!_unref(approvedAt))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)("labels.budgetapproval.tobeapproved")), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(hasClientAccess) && themes.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("project.budgetThemes.empty")), 1),
          _createVNode(ButtonContactAdmin)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "cell header-cell cell--theme-color" }, null, -1)),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)("labels.budget.themes.amount")), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("labels.budget.themes.theme")), 1),
                (_unref(hasAdminAccess))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themes.value, (theme) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: theme.id,
                  class: "row row__inner row__inner--hoverable"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(Badge, {
                      color: theme.color
                    }, null, 8, ["color"])
                  ]),
                  _createElementVNode("div", {
                    class: "cell cell--theme-amount",
                    onClick: ($event: any) => (_unref(hasAdminAccess) && editBudgetOfTheme(theme.id))
                  }, [
                    (editBudgetThemeId.value === theme.id)
                      ? (_openBlock(), _createBlock(BasicInput, {
                          key: 0,
                          "input-id": `edit-budget-${theme.id}`,
                          input: theme.budget / 100,
                          onBlur: stopEditionBudgetTheme,
                          onKeyup: _withKeys(stopEditionBudgetTheme, ["enter"]),
                          onInput: 
                  (event) =>
                    setThemeBudget(theme.id, Number(event.target.value))
                
                        }, null, 8, ["input-id", "input", "onInput"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(formatPrice)(theme.budget)), 1)
                        ], 64))
                  ], 8, _hoisted_18),
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(theme.name) + " ", 1),
                    (theme?.name && _unref(hasAdminAccess))
                      ? (_openBlock(), _createBlock(IconButton, {
                          key: 0,
                          iconName: "jam:pen-f",
                          hasBorders: false,
                          onClick: ($event: any) => (showEditThemeModal(theme.id))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(hasAdminAccess))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_unref(hasAdminAccess))
                          ? (_openBlock(), _createBlock(IconButton, {
                              key: 0,
                              "icon-name": "material-symbols:delete-outline",
                              onClick: ($event: any) => (showConfirmDelete(theme)),
                              class: "delete-theme-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("buttons.delete")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            (_unref(allocatedAmount) != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(t)("labels.budget.allocatedBudget")), 1),
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(formatPrice)(_unref(allocatedAmount))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)("labels.budget.remainingBudget")), 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(formatPrice)(_unref(remainingToAllocateAmount))), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(GraphDonutWithLabel, {
              class: "chart",
              "donut-definition": donutDefinition.value,
              labels: [
            {
              name: _unref(t)('labels.budget.allocatedBudget'),
              value: chartLabelValue.value,
            },
          ]
            }, null, 8, ["donut-definition", "labels"]),
            _createElementVNode("ul", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (theme) => {
                return (_openBlock(), _createBlock(GraphLegendItem, {
                  key: theme.id,
                  color: theme.color,
                  label: `${theme.name} - ${theme.percentageLabel}`
                }, null, 8, ["color", "label"]))
              }), 128))
            ])
          ])
        ], 64)),
    (_unref(hasAdminAccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createVNode(ButtonIcon, {
            label: _unref(t)('buttons.add'),
            "icon-name": "material-symbols:add",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddThemeModal())),
            class: "create-theme-button"
          }, null, 8, ["label"]),
          (themes.value && themes.value.length > 0)
            ? (_openBlock(), _createBlock(ButtonIcon, {
                key: 0,
                label: _unref(t)('buttons.merge'),
                "icon-name": "material-symbols:merge",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showMergeThemeModal())),
                class: "create-theme-button"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(ButtonIcon, {
            label: _unref(t)('buttons.save'),
            "icon-name": "material-symbols:save",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (saveDraft())),
            class: "create-theme-button"
          }, null, 8, ["label"]),
          (_unref(budget)?.status === 'draft')
            ? (_openBlock(), _createBlock(ButtonIcon, {
                key: 1,
                label: 
          project.value?.needsBudgetApproval
            ? _unref(t)('buttons.submitForApproval')
            : _unref(t)('buttons.submit')
        ,
                "icon-name": "material-symbols:price-check",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showSubmitBudgetModal())),
                class: "create-theme-button"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : (_unref(budget)?.status === 'sent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (project.value?.active && _unref(hasClientAccess))
              ? (_openBlock(), _createBlock(BasicButton, {
                  key: 0,
                  disabled: _unref(loadingApprove),
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (openConfirmBudgetApproveModal()), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("buttons.approve.budget")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (isAddThemeModalVisible.value)
      ? (_openBlock(), _createBlock(AddTheme, {
          key: 4,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (closeAddThemeModal()))
        }))
      : _createCommentVNode("", true),
    (themes.value && themes.value.length > 0 && isMergeThemeModalVisible.value)
      ? (_openBlock(), _createBlock(MergeTheme, {
          key: 5,
          themes: themes.value,
          "project-id": projectId.value,
          refetchQueries: refetchQueries,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (closeMergeThemeModal()))
        }, null, 8, ["themes", "project-id"]))
      : _createCommentVNode("", true),
    (themeToEdit.value)
      ? (_openBlock(), _createBlock(EditTheme, {
          key: 6,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (closeEditThemeModal())),
          theme: themeToEdit.value
        }, null, 8, ["theme"]))
      : _createCommentVNode("", true),
    (isConfirmDeleteModalVisible.value)
      ? (_openBlock(), _createBlock(ConfirmModal, {
          key: 7,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (closeConfirmDelete())),
          onNo: _cache[12] || (_cache[12] = ($event: any) => (closeConfirmDelete())),
          onYes: _cache[13] || (_cache[13] = ($event: any) => (_unref(deleteTheme)(themeToDelete.value))),
          question: _unref(t)('titles.delete')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("validateDelete", { name: themeToDelete.value.name })), 1)
          ]),
          _: 1
        }, 8, ["question"]))
      : _createCommentVNode("", true),
    (isConfirmBudgetApproveModalVisible.value)
      ? (_openBlock(), _createBlock(ConfirmModal, {
          key: 8,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (closeConfirmBudgetApproveModal())),
          onNo: _cache[15] || (_cache[15] = ($event: any) => (closeConfirmBudgetApproveModal())),
          onYes: _cache[16] || (_cache[16] = ($event: any) => (_unref(approveBudget)())),
          question: _unref(t)('modal.budgetapproval.question')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("modal.budgetapproval.content.newBudget", {
            budget: _unref(formatPrice)(project.value.budget.amount),
          })), 1),
            (project.value.previouslyApprovedBudget)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_unref(t)("modal.budgetapproval.content.previousBudget", {
            previousBudget: _unref(formatPrice)(
              project.value.previouslyApprovedBudget.amount,
            ),
          })), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["question"]))
      : _createCommentVNode("", true),
    (isSubmitBudgetModalVisible.value)
      ? (_openBlock(), _createBlock(ConfirmModal, {
          key: 9,
          onClose: _cache[17] || (_cache[17] = ($event: any) => (closeSubmitBudgetModal())),
          onNo: _cache[18] || (_cache[18] = ($event: any) => (closeSubmitBudgetModal())),
          onYes: _cache[19] || (_cache[19] = ($event: any) => (_unref(submitBudget)())),
          question: _unref(t)('modal.budgetsubmit.question')
        }, null, 8, ["question"]))
      : _createCommentVNode("", true)
  ]))
}
}

})